import Vue from "./../_lib/vue/vue.min";
import VeeValidate from "./../_lib/vue/vee-validate";
Vue.use(VeeValidate);

function redirectToEditPage(userId) {
    window.location.href =
        location.protocol +
        "//" +
        location.host +
        location.pathname +
        "?edit=" +
        userId;
}

function redirectAfterUnsubscribing() {
    window.location.href =
        location.protocol +
        "//" +
        location.host +
        location.pathname +
        "?unsubscribe=true";
}

$(document).ready(function() {
    const subscriptionTool = new Vue({
        el: "[data-subscription-tool]",
        data: function() {
            return {
                loading: false
            };
        },
        methods: {
            addSubscriptions() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.submitAddSubscriptions();
                    }
                });
            },
            editSubscriptions() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.submitEditSubscriptions();
                    }
                });
            },
            removeSubscriptions() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.submitRemoveSubscriptions();
                    }
                });
            },
            goToEditSubscriptions() {
                this.$validator.validate("tags-email-input").then(result => {
                    if (result) {
                        this.submitGoToEditSubscriptions();
                    }
                });
            },
            submitAddSubscriptions() {
                this.loading = true;
                const serialized = $("#tags-subscription-form")
                    .serialize()
                    .replace("tag-id=all&", "");
                let self = this;
                $.ajax({
                    url: $("#tags-subscription-form").attr(
                        "data-update-subscription-url"
                    ),
                    type: "post",
                    dataType: "json",
                    data: serialized,
                    success: function(data) {
                        if (window.grecaptcha) {
                            window.grecaptcha.reset();
                        }
                        self.loading = false;
                        if (!data.IsSuccess) {
                            subscriptionTool.errors.clear();
                            subscriptionTool.errors.add(
                                "ajax-validation",
                                data.Message
                            );
                        }
                        if (data.IsSuccess) {
                            //redirectToEditPage(data.UserId);
                            $("#tags-subscription-form")
                                .find(".add-subscription")
                                .show();

                            $("html, body").animate(
                                {
                                    scrollTop: 0
                                },
                                1000
                            );
                        }
                    },
                    error: function(data) {
                        self.loading = false;
                        console.error(data);
                    }
                });
            },
            submitEditSubscriptions() {
                this.loading = true;
                const serialized = $("#tags-subscription-form")
                    .serialize()
                    .replace("tag-id=all&", "");
                let self = this;
                $.ajax({
                    url: $("#tags-subscription-form").attr(
                        "data-edit-subscription-url"
                    ),
                    type: "post",
                    dataType: "json",
                    data: serialized,
                    success: function(data) {
                        window.grecaptcha.reset();
                        self.loading = false;
                        if (!data.IsSuccess) {
                            console.log(data.Message);
                            subscriptionTool.errors.clear();
                            subscriptionTool.errors.add(
                                "ajax-validation",
                                data.Message
                            );
                        }
                        if (data.IsSuccess) {
                            $("#tags-subscription-form")
                                .find(".edit-subscription")
                                .show();

                            $("html, body").animate(
                                {
                                    scrollTop: 0
                                },
                                1000
                            );
                        }
                    },
                    error: function(data) {
                        self.loading = false;
                        console.error(data);
                    }
                });
            },
            submitRemoveSubscriptions() {
                this.loading = true;
                const serialized = $("#tags-subscription-form")
                    .serialize()
                    .replace("tag-id=all&", "");
                let self = this;
                $.ajax({
                    url: $("#tags-subscription-form").attr(
                        "data-remove-subscription-url"
                    ),
                    type: "post",
                    dataType: "json",
                    data: serialized,
                    success: function(data) {
                        window.grecaptcha.reset();
                        self.loading = false;
                        if (!data.IsSuccess) {
                            console.log(data.Message);
                            subscriptionTool.errors.clear();
                            subscriptionTool.errors.add(
                                "ajax-validation",
                                data.Message
                            );
                        }
                        if (data.IsSuccess) {
                            redirectAfterUnsubscribing();
                        }
                    },
                    error: function(data) {
                        self.loading = false;
                        console.error(data);
                    }
                });
            },
            submitGoToEditSubscriptions() {
                this.loading = true;
                let self = this;
                $.ajax({
                    url: $("#tags-subscription-form").attr(
                        "data-go-to-edit-subscription-url"
                    ),
                    type: "post",
                    dataType: "json",
                    data: $("#tags-subscription-form").serialize(),
                    success: function(data) {
                        if (window.grecaptcha) {
                            window.grecaptcha.reset();
                        }
                        self.loading = false;
                        if (!data.IsSuccess) {
                            console.log(data.Message);
                            subscriptionTool.errors.clear();
                            subscriptionTool.errors.add(
                                "ajax-validation",
                                data.Message
                            );
                        }
                        if (data.IsSuccess) {
                            $("#tags-subscription-form")
                                .find(".go-to-edit-notification")
                                .show();

                            $("html, body").animate(
                                {
                                    scrollTop: 0
                                },
                                1000
                            );
                        }
                    },
                    error: function(data) {
                        self.loading = false;
                        console.error(data);
                    }
                });
            },
            checkAll(e) {
                var input = $(e.target);
                var checkboxVal = input[0].checked;
                var tagList = input.closest(".tag--list");
                var checkboxes = $("input[type='checkbox']", tagList).not(
                    "form-control__all"
                );

                checkboxes.attr("checked", checkboxVal);
            }
        }
    });

    //Initial tags slice
    $(".tag--items").each(function() {
        var $ps = $(this).find(".tag--item-form-group");
        $ps.slice(7).hide();
    });

    //Toggle visibility button
    $(".tag--items-btn").click(function() {
        var $ps = $(this)
            .closest(".tag--items")
            .find(".tag--item-form-group");
        $ps.slice(7).toggle();
        $(this).hide();
    });

    $(".tag--subscription-form").submit(function(e) {
        e.preventDefault();
    });
});
